class VietikiDropdownPicker {
  constructor() {
    this.init();
    this.globalListeners();
  }

  init() {
    const containers = document.querySelectorAll('variant-selects .product-form__input--dropdown');
    if (!containers.length) return;

    containers.forEach((inputContainer) => {
      if (inputContainer.dataset.dropdownProcessed === 'true') return;
      inputContainer.dataset.dropdownProcessed = 'true';

      const select = inputContainer.querySelector('select.select__select');
      if (!select) return;

      // Outer wrapper element container
      const dropdownWrapper = document.createElement('div');
      dropdownWrapper.className = 'vietiki-custom-dropdown';

      // Dropdown toggle trigger element
      const toggleBtn = document.createElement('button');
      toggleBtn.type = 'button';
      toggleBtn.className = 'vietiki-dropdown-toggle';
      
      const contentSpan = document.createElement('div');
      contentSpan.className = 'vietiki-dropdown-selected-content';
      
      const caretSpan = document.createElement('span');
      caretSpan.className = 'vietiki-dropdown-caret';
      caretSpan.innerHTML = `<svg viewBox="0 0 10 6" width="10"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg>`;
      
      toggleBtn.appendChild(contentSpan);
      toggleBtn.appendChild(caretSpan);

      // Options List Menu
      const menuList = document.createElement('ul');
      menuList.className = 'vietiki-dropdown-menu';

      // Parse native selection elements 
      Array.from(select.options).forEach((option) => {
        const itemLi = document.createElement('li');
        const itemBtn = document.createElement('button');
        itemBtn.type = 'button';
        itemBtn.className = 'vietiki-dropdown-item';
        
        const isUnavailable = option.disabled || option.textContent.trim() !== option.value.trim();
        if (isUnavailable) itemBtn.classList.add('is-unavailable');

        // Product photo for this colour (set in product-variant-options.liquid); falls back to the swatch
        const thumbVal = option.getAttribute('data-option-thumb');
        // Check if color swatch settings exist
        const swatchVal = option.getAttribute('data-option-swatch-value');
        if (thumbVal) {
          const thumbEl = document.createElement('img');
          thumbEl.className = 'vietiki-menu-thumb';
          thumbEl.src = thumbVal;
          thumbEl.alt = '';
          thumbEl.width = 40;
          thumbEl.height = 40;
          thumbEl.loading = 'lazy';
          itemBtn.appendChild(thumbEl);
        } else if (swatchVal) {
          const swatchEl = document.createElement('span');
          swatchEl.className = 'vietiki-menu-swatch';
          swatchEl.style.backgroundImage = swatchVal;
          const focalPoint = option.getAttribute('data-option-swatch-focal-point');
          if (focalPoint) swatchEl.style.backgroundPosition = focalPoint;
          itemBtn.appendChild(swatchEl);
        }

        const textEl = document.createElement('span');
        textEl.textContent = option.value;
        itemBtn.appendChild(textEl);

        if (option.selected) {
          itemBtn.classList.add('is-selected');
          contentSpan.innerHTML = itemBtn.innerHTML;
          // the selected colour's photo is always visible, so load it straight away (no empty box)
          contentSpan.querySelectorAll('img').forEach((img) => { img.loading = 'eager'; });
        }

        // Click Handler for custom list rows
        itemBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          if (select.value !== option.value) {
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
          dropdownWrapper.classList.remove('is-open');
        });

        itemLi.appendChild(itemBtn);
        menuList.appendChild(itemLi);
      });

      // Handle custom open/close toggle state
      toggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Close other open options row dropboxes first
        document.querySelectorAll('.vietiki-custom-dropdown').forEach(d => {
          if (d !== dropdownWrapper) d.classList.remove('is-open');
        });
        
        dropdownWrapper.classList.toggle('is-open');
      });

      dropdownWrapper.appendChild(toggleBtn);
      dropdownWrapper.appendChild(menuList);
      inputContainer.appendChild(dropdownWrapper);
    });
  }

  globalListeners() {
    // Closes list when users tap outside target dropdown area
    document.addEventListener('click', () => {
      document.querySelectorAll('.vietiki-custom-dropdown').forEach(d => d.classList.remove('is-open'));
    });

    // Re-trigger layout processing if Dawn theme asynchronously updates DOM variants markup tree
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        this.init();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
}

// Instantiate core lifecycle activation execution
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new VietikiDropdownPicker());
} else {
  new VietikiDropdownPicker();
}
